import React, { useState, useEffect } from "react";
import Preloader from "./components/Pre";
import Navbar from "./components/Navbar";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Projects from "./components/Projects/Projects";
import Footer from "./components/Footer";
import Timeline from "./components/Resume/Timeline";
import Resume from "./components/Resume/ResumeNew";
import Contact from "./components/Contact/Contact";
import AnimatedWorms from "./components/AnimatedWorms";
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  const [load, updateLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      updateLoad(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Preloader load={load} />
      <div className="App" id={load ? "no-scroll" : "scroll"}>
        <AnimatedWorms />
        <Navbar />

        {/* Sections */}
        <Home />
        <About />
        <Projects />
        <Timeline />

        <Resume />
        <Contact />
        <Footer />
      </div>
    </>
  );
}

export default App;
